module.exports = __webpack_public_path__ + "static/media/vouch3.5b0f873a.png";